import { jsx as s } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import d from "@mui/material/ToggleButton";
import u from "styled-components";
import { getFontSize as m, getPadding as p, sizes as t } from "../../theme/utils/styleUtils.js";
const f = {
  root: "toggleButtonRoot",
  disabled: "toggleButtonDisabled",
  selected: "toggleButtonSelected",
  sizeSmall: "toggleButtonSizeSmall",
  sizeLarge: "toggleButtonSizeLarge"
}, r = (o) => {
  let e = "34px";
  return o === t.extraSmall ? e = "20px" : o === t.small ? e = "24px" : o === t.large ? e = "40px" : o === t.extraLarge ? e = "46px" : o === t.superExtraLarge && (e = "56px"), e;
}, l = (o) => {
  let e = 16;
  return o === t.extraSmall || o === t.small ? e = 12 : o === t.large ? e = 20 : o === t.extraLarge ? e = 24 : o === t.superExtraLarge && (e = 30), `${e}px`;
}, B = u(d).withConfig({
  displayName: "StyledToggleButton"
})([
  "&&.toggleButtonRoot{height:",
  ";min-width:",
  ";color:",
  ";font-size:",
  ";font-weight:",
  ";line-height:1.2em;background-color:",
  ";border:none;border-radius:4px;padding:",
  ";text-transform:none;letter-spacing:normal;svg{height:",
  ";width:",
  ";}}&&.toggleButtonRoot:hover{background-color:",
  ";color:",
  ";}&&.toggleButtonRoot:active{background-color:",
  ";color:",
  ";}&&.toggleButtonRoot.toggleButtonSelected{background-color:",
  ";color:",
  ";}&&.toggleButtonRoot.toggleButtonDisabled{background-color:",
  ";color:",
  ";}&&.toggleButtonRoot.toggleButtonSelected.toggleButtonDisabled{background-color:",
  ";color:",
  ";}"
], ({ $size: o }) => r(o), ({ $size: o }) => r(o), ({ theme: o }) => o.text.primary, ({ $size: o }) => m(o), ({ theme: o }) => o.typography.fontWeightRegular, ({ theme: o }) => o.primaryBackground, ({ $size: o }) => p(o), ({ $size: o }) => l(o), ({ $size: o }) => l(o), ({ theme: o }) => o.primaryHover, ({ theme: o }) => o.colors.white, ({ theme: o }) => o.primarySelected, ({ theme: o }) => o.colors.white, ({ theme: o }) => o.primaryFill, ({ theme: o }) => o.colors.white, ({ theme: o }) => o.primaryBackground, ({ theme: o }) => o.secondaryDisabled, ({ theme: o }) => o.primaryDisabled, ({ theme: o }) => o.secondaryDisabled), R = /* @__PURE__ */ c(({ disableRipple: o = !0, disableFocusRipple: e = !0, classes: g, size: a = "medium", ...i }, n) => /* @__PURE__ */ s(B, {
  ...i,
  disableFocusRipple: e,
  disableRipple: o,
  ref: n,
  classes: {
    ...f,
    ...g
  },
  $size: a
}));
export {
  R as default
};
